export enum MedicationPricingMethod {
    PriceList = 1,
    Batch = 2,
    FDA = 3,
}
